define('core/respec-ready',["exports", "core/pubsubhub"], function (exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  const name = exports.name = "core/respec-ready"; /**
                                                    * This Module adds a `respecIsReady` property to the document object.
                                                    * The property returns a promise that settles when ReSpec finishes
                                                    * processing the document.
                                                    */


  const respecDonePromise = new Promise(resolve => {
    (0, _pubsubhub.sub)("end-all", resolve, { once: true });
  });

  Object.defineProperty(document, "respecIsReady", {
    get() {
      return respecDonePromise;
    }
  });
});
//# sourceMappingURL=respec-ready.js.map;
